import { render, staticRenderFns } from "./BaseTipPopover.vue?vue&type=template&id=4dbc1f3c"
import script from "./BaseTipPopover.vue?vue&type=script&lang=js"
export * from "./BaseTipPopover.vue?vue&type=script&lang=js"
import style0 from "./BaseTipPopover.vue?vue&type=style&index=0&id=4dbc1f3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports